import { jsx as l } from "react/jsx-runtime";
import { I as c } from "../icon-DNHpBTHs.mjs";
const o = {
  name: "check-circle-filled",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm4.712-12.491a.875.875 0 1 0-1.424-1.018l-4.4 6.16-2.27-2.27a.875.875 0 0 0-1.237 1.238l3 3a.875.875 0 0 0 1.331-.11l5-7Z" clip-rule="evenodd"/></svg>',
  keywords: ["check-circle-filled"],
  category: "status"
}, r = (e) => /* @__PURE__ */ l(c, { ...e, svg: o });
r.displayName = "IconCheckCircleFilled";
export {
  r as IconCheckCircleFilled
};
//# sourceMappingURL=check-circle-filled.es.js.map
